export default "__VITE_ASSET__DYifHf5Z__"